/* eslint-disable react/jsx-no-comment-textnodes */
import { FC, useEffect } from 'react';
import { Paper, Grid, Button, TextField } from '@material-ui/core';
import { useStyles } from './styles';
import { observer } from 'mobx-react-lite';
import { Controller, useForm } from 'react-hook-form';
import { useQuery, useMutation } from 'react-query';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { Autocomplete } from '@mui/material';
import github from '../../../assets/github.png';
export const GithubInfoTable: FC = observer(() => {
  const classes = useStyles();
  const { control, handleSubmit, setValue } = useForm<any>();
  const {
    GithubStore: { syncDepartmentGitHub, allsyncDepartmentsView, getOrganisation, Organisation },
    notificationStore: { openNotification },
  } = useStore();
  useEffect(() => {
    document.title = 'EasyIdentity: App: InfoDetail';
  }, []);
  const syncDepartmentReq = useQuery('syncDepartmentReq', () => syncDepartmentGitHub(), {
    onError: () => openNotification('error', `We are unable to get the organisation list from github`),
  });

  const getOrganisationReq = useQuery('getOrganisationReq', () => getOrganisation(), {
    onError: () => openNotification('error', `We are unable to get the organisation from github`),
  });

  const OrganisationMutation = useMutation((payload: { login: string }) => Organisation(payload), {
    mutationKey: 'OrganisationReq',
    onSuccess: () => {
      openNotification('success', 'Saved!!');
      getOrganisationReq.refetch();
    },
    onError: (error) => {
      openNotification('error', `We are unable to get the user from GitHub`);
    },
  });
  useAppPreloader(syncDepartmentReq.isFetching || OrganisationMutation.isLoading);
  useEffect(() => {
    document.title = 'EasyIdentity: App: InfoDetail';
    const savedOrganisation = getOrganisationReq?.data?.organisation;
    if (savedOrganisation && allsyncDepartmentsView.length > 0) {
      const selectedOrg = allsyncDepartmentsView.find((org) => org.login === savedOrganisation);
      if (selectedOrg) {
        setValue('organisation', selectedOrg);
      }
    }
  }, [setValue, allsyncDepartmentsView, getOrganisationReq.data]);

  const onSubmit = (data: any) => {
    if (data.organisation?.login) {
      OrganisationMutation.mutate({ login: data.organisation.login });
    } else {
      openNotification('error', 'Please select an organisation.');
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Paper className={classes.paper}>
        <div className={classes.leftCol}>
          <Grid item xs={12} className={classes.btnContainer}>
            <Button className={classes.submitBtn} type='submit' variant='contained'>
              Save changes
            </Button>
          </Grid>
        </div>
        <p className={classes.boxTitle}>All Organisation</p>
        <Grid className={classes.row} container justify='space-between'>
          <Controller
            name='organisation'
            control={control}
            render={({ field: { onChange, value, ref } }) => (
              <Autocomplete
                className={classes.input}
                options={allsyncDepartmentsView || []}
                getOptionLabel={(option) => option.login ?? ''}
                value={value || null}
                isOptionEqualToValue={(option, value) => option.login === value?.login}
                onChange={(_, newValue) => onChange(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant='outlined'
                    inputRef={ref}
                    className={classes.input}
                    label='Organisation'
                  />
                )}
              />
            )}
          />
        </Grid>
        {/* {!syncDepartmentReq.isFetching && allsyncDepartmentsView.length === 0 && ( */}
        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <h5 style={{ color: 'red', marginBottom: '16px' }}>
            If you don't see your organization, please go to your GitHub account and remove the restriction for
            third-party access. Refer to the screenshot below.
          </h5>
        </div>
        {/* )} */}
        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <img
            src={github}
            alt='GitHub third party access screenshot'
            style={{ maxWidth: '100%', height: 'auto', border: '1px solid #ddd', borderRadius: '4px' }}
          />
        </div>
      </Paper>
    </form>
  );
});
